import { Action as ReduxAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'

import { PlansState } from '../plans'

export * from './api'
export * from './boltons'
export * from './contact-preferences'
export * from './family'
export * from './history'
export * from './order'
export * from './plans'
export * from './portin'
export * from './portOut'
export * from './states'
export * from './referrals'
export * from './user'
export * from './sim-type'

export interface SmartyState {
  plans: PlansState
}

export interface SmartyAction extends ReduxAction {
  type: string
  payload?: unknown
}

export type DispatchFunction = ThunkDispatch<SmartyState, void, SmartyAction>

export interface Address {
  house_number?: string | null
  street_1?: string | null
  street_2?: string | null
  company?: string | null
  town?: string | null
  county?: string | null
  country?: string | null
  postal_code?: string | null
}

export enum DeliveryType {
  GROUP_CREATION = 'group_creation',
  SIM_REPLACEMENT = 'sim_replacement',
  ADD_SLOT = 'add_member_slot',
}

export type DeliveryAddress = {
  id: string
  name: string
  surname: string
  address: Address
  simsNumber: number
  created_at?: string
  last_time_sim_sent?: string | null
  is_owner?: boolean
  deliveryType?: DeliveryType
}

export type PropsWithClassName<P = unknown> = P & {
  className?: string | undefined
}
